import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Select from 'react-select'

// components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  Button,
  CardBody,
  FormGroup,
  Spinner
} from "reactstrap";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../../../components/Headers/Header.jsx";

//Services
import { api_DELETE, api_GET } from "../../../services/api_service.js";
import { showMessage, showQuestion } from "../../../services/message.js";

//Componentes
import DelimitacaoGoograficaFom from "./DelimitacaoGeograficaSetoresForm.jsx";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";


function DelimitacaoGeograficaSetoresList() {
  const [listaModalidades, setListaModalidades] = React.useState([])
  const [list_loading, set_list_loading] = React.useState(false);

  const [showDetail, setshowDetail] = React.useState(false);
  const [itemDetail, setitemDetail] = React.useState({});

  const [listaAuxiliar, setListaAuxiliar] = useState([]);

  const [showLoading, setshowLoading] = useState(false);

  const columnsProp = [
    { title: 'Descrição', field: 'descricao' },
    { title: 'Modalidade de coleta', field: 'modalidadeColeta' }
  ]

  const GetList = (modalidadeColetaId) => {
    set_list_loading(true);

    api_GET(`DelimitacaoGeograficaSetor/${modalidadeColetaId}`).then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setListaModalidades(result.data);
        setListaAuxiliar(result.data);
      }
    });
  }


  const [optionsModalidadesColeta, setoptionsModalidadesColeta] = React.useState([]);
  const [modalidadesColeta, setModalidadesColeta] = React.useState(null);
  const loadOptionsModalidadesColeta = () => {
    api_GET(`modalidadeColeta`).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setoptionsModalidadesColeta(result.data);
      }
    });
  }

  const Edit = (event, rowData) => {
    setitemDetail(rowData);
    setshowDetail(true);
  }

  const RemoverRegistro = (event, rowData) => {
    showQuestion("Aviso", "Tem certeza que deseja deletar o setor?", 'question', function (result) {
      if (result) {
        setshowLoading(true);

        api_DELETE('DelimitacaoGeograficaSetor/' + rowData.id).then(result => {
          if (result.status !== 204) {
            showMessage("Atenção", "Erro na operação!", 'error', function () { });
            setshowLoading(false);
          }
          else {
            setshowLoading(false);
            GetList(modalidadesColeta);
          }
        });
      }
    });
  }

  const Add = () => {
    setitemDetail(null);
    setshowDetail(true);
  };

  const handleReturn = (item) => {
    setshowDetail(false);
    setitemDetail(null);
  }

  const handleModalidadesColeta = ({ descricao, modalidadeColetaId }) => {
    setModalidadesColeta(modalidadeColetaId)
    setListaModalidades(listaAuxiliar.filter(x => x.modalidadeColetaId == modalidadeColetaId));

    //Pegando todas setores referente essa modalidade
    GetList(modalidadeColetaId);
  }

  useEffect(() => {
    loadOptionsModalidadesColeta();
  }, []);

  return <>
    {showLoading &&
      <div className="carregandoCmp">
        <div className="box">
          <label style={{ marginRight: "20px" }}>Carregando...</label>
          <Spinner size="sm" color="info" />
        </div>
      </div>
    }

    <Header />
    <Container className="mt--9" fluid>
      {!showDetail &&
        <Card className="shadow">
          <CardHeader className="border-0 mb-0">
            <Row>
              <Col md="6">
                <strong> Setores</strong>
              </Col>
              <Col md="6" className="text-right">
                <Button color="primary" type="submit" onClick={() => Add()}>
                  <FontAwesomeIcon icon={faPlus} />  Adicionar
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="mt-0">
            <Row>
              <Col md="4" lg="4" style={{ zIndex: 99999 }}>
                <FormGroup >
                  <label className="form-control-label">
                    Modalidades de Serviço
                  </label>
                  <Select
                    options={optionsModalidadesColeta}
                    getOptionLabel={({ descricao }) => descricao}
                    getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                    onChange={(value) => { handleModalidadesColeta(value) }}
                    value={modalidadesColeta ? optionsModalidadesColeta.filter(x => x.modalidadeColetaId == modalidadesColeta)[0] : null}
                    placeholder="Selecione"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="12" className="mt-1 mb-4">
                <MaterialTable
                  title="Lista de Setores"
                  columns={columnsProp}
                  data={listaModalidades}
                  isLoading={list_loading}
                  options={table_style}
                  actions={[
                    {
                      icon: 'edit',
                      tooltip: 'Editar Registro',
                      onClick: (event, rowData) => Edit(event, rowData)
                    },
                    {
                      icon: 'delete',
                      tooltip: 'Delatar Registro',
                      onClick: (event, rowData) => RemoverRegistro(event, rowData)
                    }
                  ]}
                  localization={table_translate}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      }
      {showDetail &&
        <DelimitacaoGoograficaFom
          handleReturn={handleReturn}
          item={itemDetail}
        />
      }
    </Container>
  </>;
}

export default DelimitacaoGeograficaSetoresList;